<template>
  <div class="webhooks-settings-container mt-8 pt-8 border-t border-gray-200 dark:border-zinc-700">
    <h2 class="text-xl font-semibold mb-3">Webhooks</h2>
    <p class="text-sm text-zinc-600 dark:text-zinc-400 mb-4">
      Extend your content's capabilities with Zight's webhooks. Send your data to other platforms, set up workflows and automations that help you save time.
      <br /><br />
      Ready to setup your automation? Read our
      <a href="https://support.zight.com/hc/en-us/articles/31446701947031" target="_blank" class="text-blue-500 hover:underline">Webhooks documentation</a>.
    </p>
    <div class="zt-settings-page-semismall">
      <FormKit type="form" @submit="handleUpdateWebhook" :actions="false" v-slot="{ state }">
        <FormKit
          type="url"
          name="webhook_url"
          label="Webhook URL"
          placeholder="https://your-webhook-url-here.com/notify"
          v-model="webhookUrl"
          :validation="[['url'], [isValidUrlRule, 'Please enter a valid URL (e.g., https://example.com/webhook)']]"
          validation-visibility="live"
        />
        <div class="mt-4">
          <Button submit variant="blue" :is-loading="loading" :disabled="!state.valid" data-testid="update-webhook-button"> Update webhooks</Button>
        </div>
      </FormKit>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { onMounted } from 'vue';
import { Button } from '@/storybook';
import { FormKit } from '@formkit/vue';
import { useWebhookSettings } from '@/modules/dashboard/integrations/composables/useWebhookSettings';

const { webhookUrl, loading, handleUpdateWebhook, initializeWebhookUrl, isValidUrlRule } = useWebhookSettings();

onMounted(() => {
  initializeWebhookUrl();
});
</script>

<style scoped>
.zt-settings-page-semismall {
  max-width: 600px;
}
</style>
